function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Folder / Secure / Small",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.133,
    height: 15.464,
    viewBox: "0 0 22.133 15.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 13",
    width: 22.133,
    height: 12.691,
    rx: 1,
    transform: "translate(0 2.772)",
    style: {
      fill: "#777"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 14",
    d: "M1.98 0h13.512a1.98 1.98 0 0 1 1.98 1.98H0A1.98 1.98 0 0 1 1.98 0z",
    transform: "translate(2.331)",
    style: {
      fill: "#777"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.1f8f4e75b98ce29b768e538ea5c35e89.svg";
export { ForwardRef as ReactComponent };